import { Box } from "@vinomofo/components";

export const Divider = ({ padding }: { padding?: string[] }): JSX.Element => {
  return (
    <Box
      border={0}
      borderBottom="1px solid"
      borderBottomColor="brand"
      as="hr"
      padding={padding}
    />
  );
};
